var map = {
	"./banco-general/en.json": [
		51972,
		1972
	],
	"./banco-general/es.json": [
		83719,
		3719
	],
	"./default.json": [
		70367,
		367
	],
	"./explore/en.json": [
		87215,
		7215
	],
	"./explore/es.json": [
		37276,
		7276
	],
	"./funbank/en.json": [
		46595,
		6595
	],
	"./funbank/es.json": [
		74392,
		4392
	],
	"./hdfc/en.json": [
		16237,
		6237
	],
	"./hdfc/es.json": [
		49410,
		9410
	],
	"./interbank/en.json": [
		15298,
		5298
	],
	"./interbank/es.json": [
		65773,
		5773
	],
	"./shopstar/en.json": [
		94876,
		4876
	],
	"./shopstar/es.json": [
		175,
		175
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 44226;
module.exports = webpackAsyncContext;